import React, { useEffect, useRef, useState } from "react";
import styles from './styles/TabsBar.module.css';
import { FaStar, FaFire,
        FaClock, FaGraduationCap,
        FaFilm,
        FaCalculator, FaPenNib, FaLandmark,
        FaChild, FaChartBar } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";


const TabsBar = ({ variant = "default", activeTab, setActiveTab, activeSubTab, setActiveSubTab, isMinimized }) => {
    const [alignLeft, setAlignLeft] = useState(false);
    const tabsBarRef = useRef(null);
    const tabsContentRef = useRef(null);
    const educationTabRef = useRef(null);

    const location = useLocation();
    const isOnBrowse = location.pathname.startsWith("/browse");

    const [showEducationDropdown, setShowEducationDropdown] = useState(false);

    const defaultTabs = [
        { label: "Featured", icon: FaStar },
        { label: "Most Viewed", icon: FaFire },
        { label: "Education", icon: FaGraduationCap },
        { label: "Entertainment", icon: FaFilm },
        { label: "New", icon: FaClock }
    ];

    const educationTabs = [
        { label: "Math", icon: FaCalculator },
        { label: "SAT", icon: FaPenNib },
        { label: "History", icon: FaLandmark },
        { label: "Elementary", icon: FaChild },
        { label: "Statistics", icon: FaChartBar }
    ];

    const tabs = variant === "education" ? educationTabs : defaultTabs;
        
    const navigate = useNavigate();

    useEffect(() => {
        const checkTabsWidth = () => {
            if (tabsContentRef.current && tabsBarRef.current) {
                const contentWidth = tabsContentRef.current.scrollWidth;
                const containerWidth = tabsBarRef.current.clientWidth;
                setAlignLeft(contentWidth > containerWidth);
            }
        };

        checkTabsWidth();
        window.addEventListener('resize', checkTabsWidth);
        return () => window.removeEventListener('resize', checkTabsWidth);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showEducationDropdown &&
                educationTabRef.current &&
                !educationTabRef.current.contains(event.target) &&
                !document.getElementById('educationDropdown')?.contains(event.target)
            ) {
                setShowEducationDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showEducationDropdown]);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setActiveSubTab("");
        setShowEducationDropdown(false);
    };

    return (
        <div className={variant === "education" ? styles.subtabsContainer : styles.tabsContainer}>
            <div
                className={styles.tabsBar}
                ref={tabsBarRef}
                data-align-left={alignLeft}
            >
                <div className={styles.tabsContent} ref={tabsContentRef}>
                    {tabs.map(({ label, icon: Icon }) => (
                        <div
                            key={label}
                            className={`${styles.tab} ${activeTab === label ? styles.active : ''}`}
                            onClick={() => handleTabClick(label)}
                            ref={label === "Education" ? educationTabRef : null}
                            title={isMinimized ? label : undefined}
                        >
                            <div className={styles.tabInner}>
                                <Icon className={styles.tabIcon} />
                                {!isMinimized && <span>{label}</span>}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TabsBar;
